import {FC} from "react";
import {AnimatePresence, motion} from "framer-motion";

export const FlipNumber: FC<{value: string}> = ({ value }) => {
    return (
        <AnimatePresence mode="popLayout">
            <motion.span
                key={value} // Меняет key → запускает анимацию
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -20, opacity: 0 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                style={{ display: "inline-block", position: "relative" }}
            >
                {value}
            </motion.span>
        </AnimatePresence>
    );
};